import IMG from "../../images/logo.png";
import LOGO from "/images/LinkedIn.png";

export default function Contact() {
  return (
    <section
      name="contact"
      className="w-full lg:pt-12 pb-4 lg:pb-8 bg-light-gray font-montserrat"
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-20">
        
        {/* Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-16 items-start">
          
          {/* LEFT SECTION */}
          <div className="flex flex-col lg:gap-5">
            <img
              src={IMG}
              className="-ml-6 lg:ml-0 w-56 lg:w-64"
              alt="Macro Pathways Logo"
            />

            <p className="lg:text-lg text-dark-gray leading-relaxed">
              For inquiries, reach out to us at:
              <br />
              <span className="font-semibold text-black lg:text-xl">
                info@macropathways.com
              </span>
            </p>

            {/* LinkedIn Button */}
            <a
              href="https://www.linkedin.com/company/macropathways/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 border border-gray-400 text-black mt-3 py-2 px-3 lg:py-3 lg:px-5 rounded-lg w-fit 
              hover:bg-white hover:text-black transition duration-200 shadow-sm"
            >
              <img src={LOGO} alt="LinkedIn" className="w-6 h-6" />
              <span className="font-medium text-sm lg:text-base tracking-wide">
                Connect with us on LinkedIn
              </span>
            </a>
          </div>

          {/* RIGHT SECTION */}
          <div className="bg-white rounded-xl shadow-md p-7 lg:p-10">
            <h2 className="text-lg lg:text-2xl font-semibold text-primary mb-2 lg:mb-4">
              Stay Connected
            </h2>

            <p className="text-dark-gray text-sm lg:text-base leading-relaxed mb-3 lg:mb-5">
              Have questions or want to collaborate? We’re here to support and
              partner with individuals, teams, and organizations across the
              social work landscape.
            </p>

            <p className="text-dark-gray text-sm lg:text-base">
              We look forward to hearing from you and building meaningful
              pathways together.
            </p>
          </div>
        </div>

        {/* FOOTER */}
        <p className="text-xs lg:text-sm text-gray-500 text-center mt-6 lg:mt-12 tracking-wide">
          © 2025 Macro Pathways. All rights reserved.
        </p>
      </div>
    </section>
  );
}
